<template>


  <card class="flex flex-col gap-14" padding="p-10">

    <section class="flex flex-row items-center justify-center" v-if="!requestInitialized">
      <rpm-button
        icon="fa-solid fa-bell fa-lg"
        tooltip-text="iniciar atendimento"
        @click="createSupportTicket(), startTimer()"
        label="Iniciar Atendimento"
        class="gap-2"
      />
    </section>
    <section class="flex flex-col gap-14" v-if="requestInitialized">
      <section class="grid grid-cols-1 justify-center">
<!--        <section class="items-center justify-center">-->
<!--          <rpm-input-->
<!--              label="Visibildade"-->
<!--              core-class="flex flex-row gap-3 items-center"-->
<!--              container-class="flex flex-col gap-y-3 items-center"-->
<!--              helper="Público"-->
<!--              post="Anônimo"-->
<!--              type="switch"-->
<!--              on-color="bg-gray-700"-->
<!--              off-color="bg-blue-500"-->
<!--              v-model="anonymous"-->
<!--              @change="form.source_service_id = null, selectedSourceService = {}"-->
<!--          ></rpm-input>-->
<!--        </section>-->
        <card v-if="!requestInitialized"
              class="flex flex-col items-center justify-center h-16 w-56 bg-slate-400/20 dark:bg-slate-500/20">
          <span v-if="elapsedTime < 1">00:00:00</span>
          <span v-else>{{ elapsedTime }}</span>
          <span>Protocolo: {{ ticketNumber }}</span>
        </card>
      </section>
      <section v-if="!anonymous" class="flex flex-col gap-1">
      <span class="text-xl font-bold italic">
        Solicitante
      </span>

        <section
            class="flex flex-col gap-10 p-6 border-gray-400/50 dark:border-gray-800/50"
            :class="!anonymous ? 'border rounded':'border-b border-x rounded-b-md'"
        >
          <section class="grid grid-cols-12 gap-x-4 gap-y-8">
          <span v-if="!foundPerson" class="col-span-12 text-md font-semibold italic underline">
            Dados Pessoais
          </span>


            <person-form :form="form" :errors="errors"></person-form>
          </section>

          <section class="grid grid-cols-12 gap-x-4 gap-y-8" v-if="!foundPerson">
          <span class="col-span-12 text-md font-semibold italic underline">
            Endereço do Solicitante
          </span>

            <address-form
              :address="form.address"
              :errors="errors.address"
              :block="foundPerson"
            ></address-form>

            <div class="flex flex-row justify-center col-span-12 gap-4">
              <rpm-button
                  label="Encerrar"
                  @click="finishModalOpen = true"
                  color="red"
              ></rpm-button>
              <rpm-button
                  label="Cadastrar"
                  @click="createPerson"
                  :disabled="registerPersonButtonDisabled"
              ></rpm-button>

            </div>
          </section>
        </section>
      </section>
      <section class="flex flex-col gap-1" v-if="foundPerson || anonymous">
      <span class="text-xl font-bold italic">
        Solicitação
      </span>

        <section class="flex flex-col gap-y-14 p-6 border rounded border-gray-400/50 dark:border-gray-800/50">


          <section class="flex flex-col gap-y-6">
          <span class="text-md font-semibold italic underline">
            Serviço
          </span>

            <section class="grid grid-cols-12 gap-x-4 gap-y-6">
              <rpm-input
                  label="Serviço"
                  placeholder="Serviço"
                  v-model="form.source_service_id"
                  type="select"
                  :options="!anonymous ? allSourceServices:anonymousSourceServices"
                  optionLabel="name_format"
                  optionValue="id"
                  :errors="errors.source_service_id"
                  class="col-span-4"
                  required
              ></rpm-input>

              <rpm-input
                  v-if="$can('services.services.update')"
                  label="Prioridade"
                  placeholder="Prioridade"
                  v-model="form.source_service_priority_id"
                  type="select"
                  :options="sourceServicePriorities"
                  :errors="errors.source_service_priority_id"
                  optionLabel="name"
                  optionValue="id"
                  class="col-span-4"
                  required
              ></rpm-input>

              <rpm-input
                  label="Canal"
                  placeholder="Canal"
                  v-model="form.attendance_channel_id"
                  type="select"
                  :options="channels"
                  :errors="errors.attendance_channel_id"
                  optionLabel="name"
                  optionValue="id"
                  class="col-span-4"
                  required
              ></rpm-input>
              <section v-if="Object.keys(selectedSourceService).length > 0"
                       class="flex flex-row justify-center items-center col-span-12 text-sm gap-2"
              >
                <i class="fa-solid fa-circle-info"></i>
                <span v-html="selectedSourceService.description"></span>
              </section>
              <rpm-input
                  label="Observações"
                  placeholder="Observações"
                  v-model="form.observation"
                  type="textarea"
                  height="200"
                  rows="7"
                  :errors="errors.observation"
                  class="col-span-12"
                  :required="observationRequired"
              ></rpm-input>
            </section>
          </section>

          <section class="flex flex-col gap-y-6">
            <rpm-input
              v-if="!anonymous && selectedSourceService.restricted"
              label="Identificar solicitante"
              container-class="flex flex-row-reverse gap-2 items-center w-fit"
              type="checkbox"
              off-color="bg-gray-700"
              on-color="bg-blue-500"
              v-model="form.identifiable_person"
            ></rpm-input>

            <template v-if="showAddress">
              <span class="text-md font-semibold italic underline">
                Endereço da Solicitação
              </span>

              <section class="grid grid-cols-12 gap-x-4 gap-y-8">
                <address-form
                  :required="selectedSourceService.address_required"
                  :address="form.address"
                  :errors="errors.address"
                  :notSetOnStart="true"
                ></address-form>
              </section>
            </template>
          </section>

          <questionnaire-form
              v-if="selectedSourceService.initial_source_procedure && selectedSourceService.initial_source_procedure.request_questionnaire"
              :questionnaire-object="selectedSourceService.initial_source_procedure.request_questionnaire"
              @questionnaire-update="updateQuestionnaire"
          ></questionnaire-form>

          <div class="flex flex-row justify-center col-span-12">
            <rpm-button
                label="enviar"
                @click="requestService"
                :disabled="buttonDisabled"
            ></rpm-button>
          </div>
        </section>
      </section>

    </section>


    <rpm-modal
        :header="`Serviços solicitados para o protocolo ${ticketNumber || ''}`"
        class="flex flex-col gap-y-8"
        :open="modalOpen"
        @close="finishTreatment"
        color="red"
        cancel-button-label="Encerrar"
    >

      <section class="flex gap-6">
        <span v-for="service in startedServices"
              :key="service.id">
        <badge

            color='#344767'
            class="cursor-pointer"
            @click="finishAndRedirect(service)"
        >{{ service.id }} - {{ service.name }}</badge>
        </span>
      </section>

      <template #buttons>
        <rpm-button
            label="Iniciar nova solicitação"
            @click="modalOpen = false"
        ></rpm-button>
      </template>
    </rpm-modal>

    <rpm-modal persist :open="finishModalOpen" @close="finishTreatment" color="red"
               cancel-button-label="Encerrar" header="Deseja encerrar o atendimento?">
      <template #buttons>
        <rpm-button
            label="Fechar"
            @click="finishModalOpen = false"
        ></rpm-button>
      </template>
    </rpm-modal>


  </card>

</template>


<script>

import QuestionnaireForm from '#views/questionnaire/form.vue';

import personRepository from "#repositories/personRepository";
import sourceServiceRepository from "#repositories/sourceServiceRepository";
import attendanceChannelRepository from "#repositories/attendanceChannelRepository";
import sourceServicePriorityRepository from "#repositories/sourceServicePriorityRepository";
import serviceRepository from "#repositories/serviceRepository";
import {generateTreatmentProtocol} from "#constants/appInfo";
import _ from 'lodash';

import {getErrors} from "#functions/validator.js";

import RpmAccordion from "#components/RpmAccordion.vue";
import {defaultAttendanceChannel, defaultServiceRequestPriority} from '#constants/appInfo';
import AddressForm from '#views/address/form';
import PersonForm from "#views/person/form";

import SupportTicketRepository from "#repositories/supportTicketRepository";
import RpmButton from "../../../components/RpmButton/index.vue";
import RpmModal from "#components/RpmModal.vue";
import Badge from "#components/Badge.vue";

export default {
  name: "ServiceStore",
  components: {
    RpmButton,
    RpmAccordion,
    AddressForm,
    QuestionnaireForm,
    PersonForm,
    RpmModal,
    Badge
  },
  data() {
    return {
      modalOpen: false,
      foundPerson: false,
      findPersonTimer: null,
      searchingPerson: false,
      anonymous: false,
      supportTicket: null,
      ticketNumber: '',
      form: this.defaultForm(),
      errors: {
        address: {}
      },
      elapsedTime: null,
      startTime: null,
      timeInterval: null,
      requestInitialized: false,
      channels: [],
      allSourceServices: [],
      anonymousSourceServices: [],
      sourceServicePriorities: [],
      selectedSourceService: {},
      observationRequired: false,
      showAddress: false,
      buttonDisabled: false,
      registerPersonButtonDisabled: false,
      startedServices: [],
      finishModalOpen: false
    }
  },
  methods: {
    async getAllSourceServices() {
      this.allSourceServices = (
          await sourceServiceRepository.getAllSourceServices()
      ).data;
    },
    async getAnonymousSourceServices() {
      this.anonymousSourceServices = (
          await sourceServiceRepository.getAnonymousSourceServices()
      ).data;
    },
    async getSourceServicePriorities() {
      this.sourceServicePriorities = (
          await sourceServicePriorityRepository.getSourceServicePriorities()
      ).data;

      this.form.source_service_priority_id = parseInt(defaultServiceRequestPriority)
    },
    async getChannels() {
      this.channels = (
          await attendanceChannelRepository.getChannels()
      ).data;

      this.form.attendance_channel_id = parseInt(defaultAttendanceChannel)
    },
    async findPerson(val) {
      this.foundPerson = false;
      const tempPeopleArray = (
          await personRepository.findPersonByNameOrCpf({
            data_person: val
          })
      ).data;


      if (tempPeopleArray.length == 1) {


        this.form.name = tempPeopleArray[0].name;
        this.form.cpf_cnpj = tempPeopleArray[0].cpf_cnpj;
        this.form.genre = tempPeopleArray[0].genre;
        this.form.mobile = tempPeopleArray[0].mobile;
        this.form.birthday = tempPeopleArray[0].birthday;
        this.form.email = tempPeopleArray[0].email;
        this.form.email_confirmation = tempPeopleArray[0].email;

        this.findPersonTimer = null;
        this.foundPerson = true;
        this.form.person_id = tempPeopleArray[0].id;

        this.errors = {address: {}};

      }
    },
    UpdateQuestionnaireQuestion(group, question, event) {
      question.value = event
    },
    updateQuestionnaire(event) {
      this.form.questionnaire_answers = event
    },
    async requestService() {
      this.buttonDisabled = true
      try {
        if (!this.form.source_service_priority_id) {
          this.form.source_service_priority_id = this.selectedSourceService.source_service_priority.id
        }

        serviceRepository.storeService(
          this.selectedSourceService.allow_address ? this.form : _.omit(this.form, ['address'])
        ).then((response) => {
          this.$notify('Serviço criado com sucesso', 'success');
          this.resetServiceForm()
          this.selectedSourceService = {};
          this.startedServices.push({
            id: response.data.id,
            name: response.data.source_service.name
          })
          this.modalOpen = true

        }).catch((response) => {
          getErrors(this.errors, response.errors);
          this.$notify(response.message, 'error');
        }).catch(() => {

        }).finally(() => {
          this.buttonDisabled = false
        });
      } catch (exception) {
      }
    },
    async createPerson() {
      this.registerPersonButtonDisabled = true
      personRepository.storePerson(this.form).then((response) => {
        this.errors = {address: {}};
        this.form.person_id = response.data.id;
        this.foundPerson = !this.foundPerson;
        this.$notify('Solicitante cadastrado com sucesso', 'success');
      }).catch((response) => {
        this.errors = {address: {}};
        getErrors(this.errors, response.errors);
        this.$notify('Dados Inválidos, verifique os campos', 'error');
      }).finally(() => {
        this.registerPersonButtonDisabled = false
      })
      ;
    },
    createSupportTicket() {
      this.requestInitialized = true
      SupportTicketRepository.createSupportTicket().then((response) => {
        let data = response.data
        this.$notify(data.ticket_number, 'info', 'Protocolo de atendimento', 25000)
        this.supportTicket = data.id
        this.form.support_ticket_id = this.supportTicket
        this.ticketNumber = data.ticket_number
      }).catch((errors) => {
      })
    },
    defaultForm() {
      return {
        same_address_as_person: false,
        cpf_cnpj: '',
        observation: '',
        person_id: null,
        questionnaire_answers: null,
        attendance_channel_id: parseInt(defaultAttendanceChannel),
        source_service_priority_id: parseInt(defaultServiceRequestPriority),
        execute_first_procedure: true,
        address: {},
        support_ticket_id: this.supportTicket
      }
    },
    resetServiceForm() {
      this.form = {
        ...this.form,
        source_service_id: null,
        observation: '',
      }
    },
    redirect(service) {
      this.$router.push({
        name: 'ServicesExecution',
        params: {service_id: service.id}
      });
    },
    finishTreatment() {
      if (generateTreatmentProtocol) {

        SupportTicketRepository.finishTreatment(this.ticketNumber).then((response) => {
          this.form = this.defaultForm()
          this.modalOpen = false
          this.form.support_ticket_id = null
          this.startedServices = []
          this.requestInitialized = !generateTreatmentProtocol
          this.ticketNumber = null
          this.supportTicket = null
          this.finishModalOpen = false
          this.$notify(response.message, 'success')
        }).catch((errors) => {
        })
      } else {
        this.form = this.defaultForm()
        this.modalOpen = false
        this.form.support_ticket_id = null
        this.startedServices = []
        this.requestInitialized = !generateTreatmentProtocol
        this.ticketNumber = null
        this.supportTicket = null
        this.finishModalOpen = false
      }
    },
    startTimer() {
      if (!this.timeInterval) {
        this.startTime = new Date().getTime() - this.elapsedTime;
        this.timeInterval = setInterval(this.updateTimer, 1000);
      }
    },
    finishAndRedirect(service) {
      this.finishTreatment()
      this.redirect(service)
    },
    updateTimer() {
      let currentTime = new Date().getTime();
      let timeRunning = currentTime - this.startTime
      let seconds = Math.floor(timeRunning / 1000) % 60;
      let minutes = Math.floor(timeRunning / 1000 / 60) % 60;
      let hours = Math.floor(timeRunning / 1000 / 60 / 60);
      this.elapsedTime = `${this.pad(hours)}:${this.pad(minutes)}:${this.pad(seconds)}`
    },
    pad(number) {
      return (number < 10 ? "0" : "") + number;
    },
  },
  watch: {
    anonymous() {
      sourceServiceRepository.getAnonymousSourceServices().then((response) => {
        this.anonymousSourceServices = response.data;
      })
      if (this.anonymous) {
        this.form = this.defaultForm()
      }
    },
    async 'form.source_service_id'(val) {
      if (val) {
        this.selectedSourceService = (
            await sourceServiceRepository.showSourceService(val)
        ).data;
      }

      this.showAddress = this.selectedSourceService.allow_address

    },
    'form.cpf_cnpj'(val, old) {
      let cpf_cnpj = !old || val.replace(/\D/g, '') !== old.replace(/\D/g, '');
      if (val) {
        val = val.replace(/\D/g, '');
        if (cpf_cnpj && (val.length === 11 || val.length === 14)) {
          this.findPerson(val);
        }
      }
    },

    'form.same_address_as_person'(val) {
      if (!val) {
        this.form.address = {}
      }
    },
  },
  mounted() {
    this.getAllSourceServices();
    this.getSourceServicePriorities();
    this.getChannels();
    if (this.form.same_address_as_person) {
      this.form.address = {}
    }
    this.requestInitialized = !generateTreatmentProtocol
  },
};

</script>
